import { atom, useAtom, useAtomValue } from 'jotai'

const searchAtom = atom<string>('')
const cargoAtom = atom<string>('Todos')
const typeUserAtom = atom<string>('Todos')

export const useSearch = () => useAtom(searchAtom)
export const useGetSearch = () => useAtomValue(searchAtom)
export const useCargo = () => useAtom(cargoAtom)
export const useGetCargo = () => useAtomValue(cargoAtom)
export const useTypeUser = () => useAtom(typeUserAtom)
export const useGetTypeUser = () => useAtomValue(typeUserAtom)

export const useCountFilters = () => {
  const [search] = useSearch()
  const [cargo] = useCargo()
  const [typeUser] = useTypeUser()

  const total = (search ? 1 : 0) + (cargo !== 'Todos' ? 1 : 0) + (typeUser !== 'Todos' ? 1 : 0)
  return total
}
export const useResetFilters = () => {
  const [, setSearch] = useSearch()
  const [, setCargo] = useCargo()
  const [, setTypeUser] = useTypeUser()

  return () => {
    setSearch('')
    setCargo('Todos')
    setTypeUser('Todos')
  }
}
